// extracted by mini-css-extract-plugin
export default {"loading_spinner":"loading_spinner","show_loading_spinner":"show_loading_spinner","scs_loader":"scs_loader","load2":"load2"};